<template>
  <div id="index">
    <el-container>
      <el-main :class="client == 'web' ? 'el-main-web' : 'el-main-app'">
        <img
          v-if="client == 'web'"
          src="~assets/img/splash_logo.png"
          style="
            width: 475px;
            height: 203px;
            position: absolute;
            top: 150px;
            left: 124px;
          "
        />
        <img
          v-if="client != 'web'"
          src="~assets/img/IRlogo.png"
          style="width: 200px; position: absolute; top: 20px; left: 20px"
        />
        <img
          v-if="client != 'web'"
          src="~assets/img/logo.png"
          style="
            width: 150px;
            position: absolute;
            top: 160px;
            left: calc(50% - 75px);
          "
        />
        <span
          v-if="client != 'web'"
          style="
            width: 100%;
            position: absolute;
            top: 220px;
            left: 0;
            text-align: center;
            color: #828393;
            font-size: 16px;
            font-weight: 600;
          "
          >{{ $t("title.title") }}
        </span>

        <span
          :class="client == 'web' ? 'tipWeb' : 'tipApp'"
          v-if="errcode == ''"
          >{{ $t("desc.accountVerificationSuccessful") }}</span
        >
        <span
          @click="returnLogin()"
          :class="client == 'web' ? 'tipWeb' : 'tipApp'"
          v-if="errcode != ''"
          >{{ $t("desc.accountVerificationFail") }}{{ skipSecond }}{{ $t("desc.returnLoginPageSecond") }}</span
        >

        <!-- <strong>SSO登录</strong> -->
        <!-- <span v-if="errcode == ''">账号验证成功，跳转中...</span>
          <span v-if="errcode != ''"
            >账号验证失败，{{ skipSecond }}秒后返回登录页面</span
          > -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  GetUserMenu,
  getUserBrand,
  getSsoLoginInfo,
  getSamlLogoutRequest,
} from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
import {
  setItemToLocalstorage,
  delItemFormLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
import { delCookie } from "../../../utils/package-cookies";
import router from "../../../src/router/index";
import defaultSettings from "@/config/defaultSettings";

export default {
  name: "Index",
  data() {
    return {
      skipSecond: 10,
      skipUrl: "",
      // 对话框显示和隐藏
      dialogVisible: false,
      brand: "IR",
      para: "",
      tipmsg: "",
      errcode: "",
      client: "web", //App 或 Web
      targetUrl: "/index", //登录成功后跳转的页面
    };
  },
  created: async function () {
    this.brand = Globals.VUE_APP_Brand;
    var that = this;
    let hash = window.location.href;
    if (hash != "" && hash.indexOf("?") >= 0) {
      let u = "";
      let token = "";
      let vid = "";
      let para = "";
      let errcode = "";
      let str = hash.split("?")[1];
      var paras = str.split("&");
      paras.forEach(function (o, i) {
        var subArr = o.split("=");
        if (subArr[0] == "u") {
          u = decodeURIComponent(subArr[1]);
        } else if (subArr[0] == "token") {
          token = decodeURIComponent(subArr[1]);
        } else if (subArr[0] == "vid") {
          vid = decodeURIComponent(subArr[1]);
        } else if (subArr[0] == "p") {
          para = decodeURIComponent(subArr[1]);
        } else if (subArr[0] == "errcode") {
          errcode = decodeURIComponent(subArr[1]);
        } else if (subArr[0] == "client") {
          that.client = decodeURIComponent(subArr[1]);
        }
      });
      this.errcode = errcode;
      this.para = para;
      //that.tipmsg = "账号验证成功，跳转中...";
      if (errcode != "") {
        //that.tipmsg = "账号验证失败，10秒后返回登录页面";
        // if (errcode == "1") {
        //   that.$message({
        //     showClose: true,
        //     message: "IoT系统账号不存在",
        //     type: "error",
        //     duration: 0,
        //   });
        //   return false;
        // } else if (errcode == "2") {
        //   that.tipmsg="";
        //   that.$message({
        //     showClose: true,
        //     message: "IoT系统账号类型不对，请设置为SSO类型后再使用SSO登录",
        //     type: "error",
        //     duration: 0,
        //   });
        //   return false;
        // } else {
        //   that.tipmsg="";
        //   that.$message({
        //     showClose: true,
        //     message: "SSO登录失败",
        //     type: "error",
        //     duration: 0,
        //   });
        //   return false;
        // }

        setInterval(function () {
          var i = that.skipSecond;
          if (i > 0) that.skipSecond = i - 1;
        }, 1000);
        setTimeout(function () {
          //window.location.href = self.skipUrl;
          that.getSamlLogoutRequest(u);
          //that.$router.push("/ssologin");
        }, 10000);
        return false;
      }

      if (token != "") {
        setItemToLocalstorage("auth", token);
      } else {
        that.$message({
          showClose: true,
          message: "SSO登录失败",
          type: "error",
          duration: 0,
        });
        return false;
      }
      if (vid != "") {
        setCookie("vid", vid, 1);
      }

      try {
        let res = await getSsoLoginInfo(); //let res = await getSsoLoginInfo(u);
        if (res.success === true) {
          setItemToLocalstorage("userName", res.result.userName);
          setCookie("userName", res.result.userName, 1);
          setCookie("userSessionID", res.result.sessionId, 1); //存储sessionID
          setItemToLocalstorage("userInfo", res.result.userId); //存储用户信息
          setItemToLocalstorage("accountType", res.result.accountType); //存储账号类型
          setItemToLocalstorage("auth", res.result.accessToken);
          setItemToLocalstorage("roles", res.result.roles);
          localStorage.setItem("isRefresh", res.result.isRefresh);
          let userBrand = await this.getCurUserBrand();
          if (
            userBrand &&
            userBrand.indexOf(localStorage.getItem("user_brand")) == -1
          ) {
            localStorage.setItem("user_brand", userBrand.split(",")[0]);
          }
          localStorage.setItem("isneedchange", res.result.isNeedChangePass);
          if (
            res.result.verifyId != undefined &&
            res.result.verifyId != null &&
            res.result.verifyId != ""
          ) {
            setCookie("vid", res.result.verifyId, 1);
          }
          that.getUserMenu();
        }
      } catch (err) {
        if (err != undefined) {
          var msg = err.error.message.replace("[", "").replace("]", "");
          that.$message({
            showClose: true,
            message: that.$t("loginTips." + msg),
            type: "error",
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      menuListStore: "menuListState",
      authOperationStore: "authOperationState",
    }),
  },
  methods: {
    ...mapMutations([
      "setLanguage",
      "setMenuListState",
      "setAuthOperationState",
    ]),
    // changeLanguage(e) {
    //   window.localStorage.setItem("user_lang", e);
    //   this.setLanguage(e);
    //   window.location.reload();
    // },
    returnLogin() {
      this.getSamlLogoutRequest();
      //this.$router.push("/ssologin");
    },

    getSamlLogoutRequest(u) {
      var that = this;
      let para_brand = "ir";
      let hash = window.location.href;
      if (
        hash.indexOf("testgdweb.irconnectivity.com") >= 0 ||
        hash.indexOf("gdiconn.irconnectivity.com/") >= 0 ||
        hash.indexOf("gdapiconn.irconnectivity.com/") >= 0
      ) {
        para_brand = "gd";
      }
      //var userId = getItemFormLocalstorage("userInfo");
      getSamlLogoutRequest(para_brand, u).then((res) => {
        delCookie("userSessionID");
        delItemFormLocalstorage("userInfo");
        delItemFormLocalstorage("userName");
        delItemFormLocalstorage("auth");
        delItemFormLocalstorage("TokenExpire");
        delItemFormLocalstorage("refreshtime");
        delItemFormLocalstorage("expires_in");
        delItemFormLocalstorage("menuData");
        delItemFormLocalstorage("authOperations");
        delItemFormLocalstorage("AlarmCount");
        delItemFormLocalstorage("isneedchange");
        sessionStorage.clear();
        delCookie("auth");
        delCookie("Abp.AuthToken");
        delCookie("vid");
        var samlUrl = res.result;
        window.location.href = samlUrl;
      });
    },
    async getCurUserBrand() {
      let that = this;
      let res = await getUserBrand();
      return res.result;
    },
    async getUserMenu() {
      var that = this;
      await GetUserMenu()
        .then(
          (res) => {
            if (res.success === true) {
              var menuList = res.result;
              var isHasDefault = false;
              // var firstPage = "/";
              var isEmptyMenu = false;
              if (menuList == null || menuList.length == 0) {
                isEmptyMenu = true;
              } else {
                //缓存用户操作权限
                var authOperations = [];
                menuList.forEach(function (obj, index) {
                  obj.operations.forEach((op1) => {
                    authOperations.push(op1);
                  });
                  if (obj.children.length > 0) {
                    obj.children.forEach(function (o, i) {
                      o.operations.forEach((op2) => {
                        authOperations.push(op2);
                      });
                    });
                  }
                });

                // that.setMenuListState(menuList);
                // that.setAuthOperationState(authOperations);
                menuList = menuList.filter((a) => a.code != "MultiBrand_View" && a.code != "EmcStationMonitorScreen_View");
                setItemToLocalstorage("menuData", menuList);
                setItemToLocalstorage("authOperations", authOperations);

                menuList.forEach(function (obj, index) {
                  if (obj.children.length == 0) {
                    isEmptyMenu = true;
                  } else {
                    isEmptyMenu = false;
                  }
                });
              }

              if (isEmptyMenu) {
                that.$message({
                  showClose: true,
                  message: that.$t("tips.noPerimission"),
                  type: "error",
                });
              } else {
                menuList.forEach(function (obj) {
                  if (obj.url == "/index") isHasDefault = true;
                });
                if (isHasDefault) {
                  that.rediectToPage();
                  //window.location.href = "/welcome";
                } else {
                  menuList.forEach(function (obj, index) {
                    if (index == 0) {
                      if (obj.children.length > 0) {
                        obj.children.forEach(function (o, i) {
                          // if (i == 0) firstPage = o.url;
                          if (i == 0) that.targetUrl = o.url;
                        });
                      }
                    }
                  });

                  that.rediectToPage();
                  //window.location.href = "/welcome";
                }
              }
            } else {
              that.$message({
                showClose: true,
                message: "error",
                type: "error",
              });
            }
          },
          (err) => {
            if (err.error.code != 401) {
              that.$message.error(err.error.message);
            }
          }
        )
        .catch((err) => {
          if (err.error.code != 401) {
            that.$message.error(err.error.message);
          }
        });
    },
    rediectToPage() {
      var that = this;
      var ssoPara = that.para;
      var parr = ssoPara.split("-");
      var redirectPage = "";
      var paraDsn = "";
      //var paraBrand = "";
      if (parr.length > 0) {
        parr.forEach(function (o, i) {
          var subArr = o.split("_");
          if (subArr[0] == "page") {
            redirectPage = decodeURIComponent(subArr[1]);
          } else if (subArr[0] == "dsn") {
            paraDsn = decodeURIComponent(subArr[1]);
            if (subArr.length > 2) {
              for (i = 1; i <= subArr.length - 2; i++) {
                paraDsn =
                  paraDsn + "_" + decodeURIComponent(subArr[subArr.length - i]);
              }
            }
          }
          // else if (subArr[0] == "brand") {
          //   paraBrand = decodeURIComponent(subArr[1]);
          //}
        });
      }
      if (redirectPage != "") {
        if (redirectPage == "monitor") {
          window.location.href = "/deviceMonitor?dsn=" + paraDsn;
        }
      } else {
        //window.location.href = "/welcome";
        window.location.href = that.targetUrl;
      }
    },
    forgetPws() {
      this.$router.push("/ResetPassword");
    },
  },
};
</script>

<style lang="less">
.theme1 {
  .el-main-web {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url("~assets/img/splash.jpg");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .el-main-app {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #282c38;
    // background-image: url("~assets/img/splash.jpg");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .el-main {
    padding: 20px 7%;
    width: 100%;
  }
  .tipWeb {
    margin: 0 2px;
    padding: 8px 20px 6px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    font-family: Arial, "microsoft yahei";
    border: 1px solid rgba(130, 131, 147, 0.2);
    color: #828393;
    background: #fff;
    position: absolute;
    top: 400px;
    left: 124px;
    cursor: pointer;
  }
  .tipApp {
    color: #a6a8b4;
    text-align: center;
    display: block;
    font-size: 20px;
    font-weight: 400;
    line-height: 16px;
    width: 100%;
    position: absolute;
    top: 400px;
    left: 0;
  }
}
</style>
